import * as yup from 'yup';
import { Theme } from 'baseui/styles';
import { RenderConfig, Row } from 'commons-ui';
import TextInput from 'commons-ui/src/components/inputWrapper/TextInput';
import TextAreaInput from 'commons-ui/src/components/inputWrapper/TextAreaInput';
import { FORM_FIELD_KEYS } from '../constants';

export const validationSchema = yup.object().shape({
	[FORM_FIELD_KEYS.TICKET_ID]: yup
		.string()
		.required('Ticket ID is required')
		.max(50, 'Ticket ID must be at most 50 characters')
		.matches(/^[A-Za-z0-9-]+$/, 'Only alphanumeric characters and "-" are allowed'),
	[FORM_FIELD_KEYS.DESCRIPTION]: yup
		.string()
		.max(500, 'Description must be at most 500 characters')
		.matches(/^[A-Za-z0-9\.\-\s]*$/, 'Only alphanumeric characters, "-", "." and spaces are allowed')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.TICKET_ID]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.TICKET_ID)
		.setLabel('Ticket ID')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			maxLength: 50,
			size: 'default',
			overrides: {
				Input: {
					style: ({ $theme }: { $theme: Theme }) => ({
						[$theme.mediaQuery.small]: {
							fontSize: '15px'
						}
					})
				}
			}
		}),
	[FORM_FIELD_KEYS.DESCRIPTION]: new RenderConfig()
		.setName(FORM_FIELD_KEYS.DESCRIPTION)
		.setLabel('Description')
		.setRenderer(TextAreaInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			rows: 4,
			maxLength: 500,
			size: 'default',
			overrides: {
				Input: {
					style: ({ $theme }: { $theme: Theme }) => ({
						resize: 'vertical',
						minHeight: '80px',
						[$theme.mediaQuery.small]: {
							fontSize: '15px'
						}
					})
				}
			}
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.TICKET_ID), new Row(FORM_FIELD_KEYS.DESCRIPTION)];
